/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimplifiedLookupResponseViewModel
 */
export interface SimplifiedLookupResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof SimplifiedLookupResponseViewModel
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof SimplifiedLookupResponseViewModel
     */
    description: string;
}

/**
 * Check if a given object implements the SimplifiedLookupResponseViewModel interface.
 */
export function instanceOfSimplifiedLookupResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function SimplifiedLookupResponseViewModelFromJSON(json: any): SimplifiedLookupResponseViewModel {
    return SimplifiedLookupResponseViewModelFromJSONTyped(json, false);
}

export function SimplifiedLookupResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimplifiedLookupResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['Value'],
        'description': json['Description'],
    };
}

export function SimplifiedLookupResponseViewModelToJSON(value?: SimplifiedLookupResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Value': value.value,
        'Description': value.description,
    };
}

